import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_threatened_intimidated_harassed_punished_terminated'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_threatened_intimidated_harassed_punished_terminated',
  name: 'Has the facility threatened, intimidated, harassed, punished, terminated or not renewed worker contracts due to their worker representative role or activities?',
  description:
    'This question is about retaliation against workers for their representative role or activities (not including trade union membership or activities, which are covered separately). This question covers non-union worker representatives, including those serving on, e.g., OSH committees, bipartite committees.\r\r\n\r\r\n"Retaliation" in this context refers to negative workplace consequences. Retaliation can take the form of: Threats/intimidation/harassment (potential negative consequences) or Punishment/Termination (actual negative consequences).\r\r\n\r\r\n"Threatened, intimidated, or harassed" means the facility threatened, intimidated, or harassed workers for their (non-union) representative role or activities.\r\r\nFor example, the facility may have threatened to terminate (i.e. fire) a worker for their representative activities.\r\r\n\r\r\n"Punished" means the facility punished workers for their (non-union) representative role or activities.\r\r\nFor example, the facility might have demoted (i.e. move to a lower position) a worker for their representative activities. Consequences include demotion, discipline, firing, salary reduction, job reassignment etc.\r\r\n\r\r\n"Terminated workers or did not renew their contract" means the facility has terminated workers or did not renew their contract due to their (non-union) representative role or activities. For example, the facility may have terminated (i.e. fired) a worker for their representative activities.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'erg-2--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12650,
  sectionId: '2.2.10.2',
  impactArea: 'Workplace Cooperation',
  impactAreaId: 'WORKPLACE_COOPERATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
